import { withTableView } from '@components/enitity/table/Table.view'
import { FlatsTable } from '@features/flats'
import { useTranslation } from 'react-i18next'

export const Flats = () => {
  const { t } = useTranslation('flat')

  const TableWithView = withTableView(FlatsTable, t('title'))

  return <TableWithView />
}
